"use client";

import React from "react";
import { PageHomeSchema } from "@/sanity/pages/PageHomeTemplate";

import { usePathname } from "next/navigation";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import PricingTableNew from "./PricingTableNew";
import ChipSerif from "@/components/global/ui/ChipSerif";
import { cn } from "@/lib/utils";
import { CTAButton } from "@/shadcn/ui/button";

export default function FundingSection({
  data,
  className,
  futures = false,
}: {
  data: PageHomeSchema;
  className?: string;
  futures?: boolean;
}) {
  const pathname = usePathname();
  const lang =
    pathname.slice(-3) === "/de" || pathname === "/de"
      ? "de"
      : pathname.slice(-3) === "/br" || pathname === "/br"
        ? "br"
        : "en";
  return (
    <section
      id="pricing"
      className={cn("w-full h-full lg:px-0", className)}
      style={{ overflowAnchor: "none" }}
    >
      <div className="container relative">
        <div className="w-[min(146.625rem,100%)] mx-auto">
          <div className="flex flex-col justify-center items-center lg:justify-start mb-[3rem] lg:mb-[4rem] text-center">
            {data?.tableChip && (
              <p className="text-[2.25rem] text-black/70 mb-[1rem] font-instrument">
                {data.tableChip}
              </p>
            )}

            {data?.tableTitle && (
              <div className="richtext prose-p:w-[min(56.5rem,100%)] mb-[1.5rem]">
                <PortableText
                  value={data.tableTitle}
                  components={richTextComponent}
                />
              </div>
            )}
          </div>

          <PricingTableNew
            pricingAssets={data?.pricingAssets ?? []}
            fieldDescriptions={data?.fieldDescriptions}
            lang={lang}
            stepOneTitle={data?.stepOneTitle}
            stepOneDescription={data?.stepOneDescription}
            stepTwoTitle={data?.stepTwoTitle}
            stepTwoDescription={data?.stepTwoDescription}
          />
        </div>
      </div>
    </section>
  );
}
